export default __webpack_public_path__ + "static/tagfp-logo-white-fe8acf4a7318b821ac3874891bb4685d.svg";